// extracted by mini-css-extract-plugin
export default {"citationList":"_12-SourcesCited_citationList__CFYK0","selectedCitation":"_12-SourcesCited_selectedCitation__bWvDq"};